import { BodySecondary, H1 } from '@liveauctioneers/hammer-ui-core/text';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import styled from 'styled-components';

const NewSearchSteps = () => {
    return (
        <Spacer>
            <StyledPageTitle>
                <FormattedMessage id="search_alerts.start_new_search" />
            </StyledPageTitle>
            <StepsList>
                <li>
                    <BodySecondary>
                        <FormattedMessage id="search_alerts.new_search_1" />
                    </BodySecondary>
                </li>
                <li>
                    <BodySecondary>
                        <FormattedMessage id="search_alerts.new_search_2" />
                    </BodySecondary>
                </li>
                <li>
                    <BodySecondary>
                        <FormattedMessage id="search_alerts.new_search_3" />
                    </BodySecondary>
                </li>
            </StepsList>
        </Spacer>
    );
};

export default NewSearchSteps;

const Spacer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    position: relative;
    min-height: 400px;
    padding: 0 20px 0;
    max-width: ${({ theme }) => theme.breakpoints.pageWidth};
    margin: 0 auto;

    @media (max-width: 1200px) {
        margin-left: 0;
        min-width: 55%;
        max-width: 100%;
        min-height: 300px;
    }
`;

const StyledPageTitle = styled(H1)`
    margin-top: 32px;
`;

const StepsList = styled.ol`
    padding-left: 20px;
    margin: 32px 0 0;
`;
